<w-step title="{{'additionalParties' | translate}}">
  <f-facet name="step-content-top" >
    @if (!readOnly) {
      <w-button-group>
        <button id="addComplainant" w-button [size]="'small'" (click)="addComplainant()" [buttonType]="'text'">{{addReqPartyBtn | translate }}</button>
        <button id="addRespondent" w-button [size]="'small'" (click)="addRespondent()" [buttonType]="'text'">{{addResPartyBtn | translate }}</button>
      </w-button-group>
    }

    @if (additionalParties.length > 0) {
      @for (item of additionalParties; track item) {
        <w-view-panel [reviewMode]="false" [ignoreReviewMode]="false" [disabled]="false" [highlighted]="false"
          [folded]="true">
          <f-facet name="primary-action">
            <button w-button [label]="'%1'" [size]="'medium'" (click)="editParty(item)" [buttonType]="'edit'"></button>
            @if (!readOnly) {
              <button  w-button [label]="'%1'" [size]="'medium'" (click)="deleteParty(item)" [buttonType]="'delete'"></button>
            }
          </f-facet>
          <f-facet name="section-unfolded">
            <w-section>
              <w-slot>
                <w-field label="{{'name' | translate}}"> {{item.name}} </w-field>
                <w-field label="{{'country' | translate}}" >  {{item.country}}   </w-field>
                <w-field label="{{'address' | translate}}">  {{item.address}}   </w-field>
              </w-slot>
              <w-slot>
                <w-field label="{{'party' | translate}}"> {{item.type | translate}}  </w-field>
                <w-field label="{{'email' | translate}}"> {{item.email}} </w-field>
                <w-field label="{{'tel' | translate}}"> {{item.telephone}} </w-field>
              </w-slot>
              @if (this.editCase) {
                <w-slot>
                  <w-select-one [label]="'common.genderClaimant' | translate" [labelOnTop]="true" [disabled]='true' [isReadOnly]='true' [(ngModel)]="item.gender" [options]="genderOptions"> </w-select-one>
                  <w-select-one [label]="'common.typeClaimant' | translate" [labelOnTop]="true" [disabled]='true' [isReadOnly]='true' [(ngModel)]="item.typeOfParty" [options]="typeOfPartyOptions"> </w-select-one>
                </w-slot>
              }
            </w-section>
          </f-facet>
          <f-facet name="section-folded">
            <w-section>
              <w-slot>
                <w-field label="{{'name' | translate}}">   {{item.name}} </w-field>
              </w-slot>
              <w-slot>
                <w-field label="{{'party' | translate}}"> {{item.type | translate}} </w-field>
              </w-slot>
            </w-section>
          </f-facet>
        </w-view-panel>
      }
    }

    <w-edit-panel [hidden]="!editAdd">
      <f-facet name="actions">
        <button w-button (click)="toggleAddEdit()">{{'cancel'|translate}}</button>
        @if (!readOnly) {
          <button id="saveParty" w-button [isDefault]="true" (click)="saveParty()">{{'save'|translate}}</button>
        }
      </f-facet>
      <w-section>
        <w-slot>
          @if (readOnly) {
            <w-input-text [disabled]='true' [isReadOnly]='true' label="{{'name' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.name" name="name" (wKeyup)="countCharsVal(this)">
              @if (validName) {
                <f-facet name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
              }
            </w-input-text>
          }
          @if (!readOnly) {
            <w-input-text id="partyName"  label="{{'name' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.name" name="name" (wKeyup)="countCharsVal(this)">
              @if (validName) {
                <f-facet name="error" id="partyNameLength">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
              }
              @if (ValidationName) {
                <f-facet name="error">{{'validationWarning' | translate }}</f-facet>
              }
            </w-input-text>
          }
          @if (readOnly) {
            <w-input-text [disabled]='true' [isReadOnly]='true' label="{{'address' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.address" name="address" (wKeyup)="countCharsVal(this)" >
              @if (validAddress) {
                <f-facet name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
              }
            </w-input-text>
          }
          @if (!readOnly) {
            <w-input-text id="partyAddress" label="{{'address' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.address" name="address" (wKeyup)="countCharsVal(this)" >
              @if (validAddress) {
                <f-facet name="error" id="partyNameLength">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
              }
            </w-input-text>
          }

          @if (readOnly && this.editCase) {
            <w-input-text [disabled]='true' [isReadOnly]='true' label="{{'common.stateOrCountyClaimantRepBy' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.stateOrCounty"
            name="stateOrCounty" >  </w-input-text>
          }
          @if (!readOnly && this.editCase) {
            <w-input-text id="partyState" label="{{'common.stateOrCountyClaimantRepBy' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.stateOrCounty"
            name="stateOrCounty" >  </w-input-text>
          }

          @if (readOnly) {
            <w-input-text [disabled]='true' [isReadOnly]='true' label="{{'tel' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.telephone"  name="telephone" (wKeyup)="countCharsVal(this)" >
              @if (validTel) {
                <f-facet name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
              }
            </w-input-text>
          }

          @if (!readOnly) {
            <w-input-text id="partyTelephone" label="{{'tel' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.telephone"  name="telephone" (wKeyup)="countCharsVal(this)" >
              @if (validTel) {
                <f-facet name="error" id="partyTelephoneLength">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
              }
            </w-input-text>
          }

          @if (readOnly && this.dispCountry) {
            <w-select-one [disabled]='true' [isReadOnly]='true' label="{{'country' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.countryCode" [options]="optionsCountries" ></w-select-one>
          }
          @if (!readOnly && this.dispCountry) {
            <w-select-one id="partyCountry" label="{{'country' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.countryCode" [options]="optionsCountries" ></w-select-one>
          }

          @if (readOnly) {
            <w-input-text [disabled]='true' [isReadOnly]='true' label="{{'email' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.email" (wKeyup)="onEmailValid(this)" (wKeyup)="countCharsVal(this)"  name="email"  [type]="'email'">
              @if (invalidEmailsValidation) {
                <f-facet name="error">{{'validationEmail' | translate  }}<br></f-facet>
              }
              @if (validEmail) {
                <f-facet name="error">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
              }
            </w-input-text>
          }
          @if (!readOnly) {
            <w-input-text id="partyEmail" label="{{'email' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.email" (wKeyup)="onEmailValid(this)" (wKeyup)="countCharsVal(this)"  name="email"  [type]="'email'">
              @if (invalidEmailsValidation) {
                <f-facet name="error">{{'validationEmail' | translate  }}<br></f-facet>
              }
              @if (validEmail) {
                <f-facet name="error" id="partyEmailLength">{{'textLengthWarning' | translate: {value: '255'} }}</f-facet>
              }
            </w-input-text>
          }

          @if (readOnly && this.editCase) {
            <w-select-one [disabled]='true' [isReadOnly]='true' [label]="'common.typeClaimant' | translate" [labelOnTop]="true" [(ngModel)]="editedParty.typeOfParty"
            [options]="typeOfPartyOptions" > </w-select-one>
          }
          @if (!readOnly && this.editCase) {
            <w-select-one  [label]="'common.typeClaimant' | translate" [labelOnTop]="true" [(ngModel)]="editedParty.typeOfParty"
            [options]="typeOfPartyOptions" > </w-select-one>
          }

          @if (readOnly && this.editCase) {
            <w-input-text [disabled]='true' [isReadOnly]='true' label="{{'common.typeClaimantOther' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.typeOfPartyOther"
            name="typeOfPartyOther" >  </w-input-text>
          }
          @if (!readOnly && this.editCase) {
            <w-input-text label="{{'common.typeClaimantOther' | translate}}" [labelOnTop]="true" [(ngModel)]="editedParty.typeOfPartyOther"
            name="typeOfPartyOther" >  </w-input-text>
          }


          @if (readOnly && this.editCase) {
            <w-select-one [disabled]='true' [isReadOnly]='true'  [label]="'common.genderClaimant' | translate" [labelOnTop]="true" [(ngModel)]="editedParty.gender"
              [options]="genderOptions" >
            </w-select-one>
          }
          @if (!readOnly && this.editCase) {
            <w-select-one  [label]="'common.genderClaimant' | translate" [labelOnTop]="true" [(ngModel)]="editedParty.gender"
              [options]="genderOptions" >
            </w-select-one>
          }


        </w-slot>
      </w-section>
    </w-edit-panel>

  </f-facet>
</w-step>
